module.exports = __webpack_public_path__ + "static/media/admin_pin.cca44001.png";